import * as React from 'react';
import { startOfToday } from 'date-fns';
import { parse as _parse } from '../../../internal/utils/date';
var parse = _parse('yyyy-MM-dd');
export function useDateLimitValue(value) {
  return React.useMemo(function () {
    if (value instanceof Date) {
      return value;
    }
    if (typeof value === 'string') {
      if (value === 'today') {
        return startOfToday();
      }
      return parse(value);
    }
    return;
  }, [value]);
}